import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

import CustomButton from '../button/CustomButton';
import {
  WholeWrapper,
  ModalHeader,
  ModalHeaderLines,
  ModalPrimaryText,
  ModalMain,
  ModalSecondaryText,
  ButtonsFlexWrapper,
  ButtonWrapper,
  ModalSecondaryQuestion,
} from './components';

import CustomInput from '../input/CustomInput';

const customStyles = {
  overlay: {
    backgroundColor: '#05000066',
    zIndex: '44444445',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: 'hidden auto',
  },
  content: {
    background: 'transparent',
    zIndex: '11111111',
    width: 'Calc(100% - 20px)',
    maxWidth: '588px',
    minWidth: '300px',
    height: 'fit-content',
    top: '10px',
    minHeight: 'Calc(100vh - 20px)',
    display: 'flex',
    alignItems: 'center',
    left: 'max(10px, Calc(50% - 294px))',
    color: '#001212',
    borderRadius: '12px',
    border: 'none',
    padding: '0 ',
    pointerEvents: 'all',
  },
};

const CancelProgramModal = ({
  modalOpen,
  closeModal,
  submitModal,
  headingText,
  contentText,
  rejectModal,
  rejectText,
  submitText,
  neg,
  paddings,
  typeText = 'CANCEL_PROGRAM'
}) => {
  const [text, setText] = useState('');

  useEffect(() => {
    setText('')
  }, [modalOpen])

  return (
    <Modal onRequestClose={closeModal} isOpen={!!modalOpen} style={customStyles}>
      <WholeWrapper>
        <ModalHeader neg={neg}>
          <ModalHeaderLines />
        </ModalHeader>
        <ModalMain style={paddings?.[0] ? { paddingTop: paddings?.[0] } : {}}>
          {headingText && <ModalPrimaryText>{headingText}</ModalPrimaryText>}
          {contentText && <ModalSecondaryText>{contentText}</ModalSecondaryText>}
          <ModalSecondaryQuestion>Type "{typeText}" to proceed</ModalSecondaryQuestion>
          <CustomInput
            color="#373333"
            outlined
            borderRadius="8px"
            height="5.6rem"
            onChange={(val) => setText(val)}
            value={ text }
            margin="0"
            placeholder="Type here..."
            borderColor="rgba(0, 0, 0, 0.07)"
            style={{
              maxWidth: '40rem',
              margin: '2.4rem 0',
              fontSize: 16,
            }}
          />
          <ButtonsFlexWrapper style={paddings?.[1] ? { marginTop: paddings?.[1] } : {}}>
            <ButtonWrapper>
              <CustomButton
                fontSize="14px"
                fontFamily={neg ? 'Roboto-b' : 'Roboto-r'}
                onClick={rejectModal || closeModal}
                borderRadius="8px"
              >
                {'Discard'}
              </CustomButton>
            </ButtonWrapper>
            <ButtonWrapper>
              <CustomButton
                fontSize="14px"
                fontFamily={neg ? 'Roboto-b' : 'Roboto-r'}
                backgroundColor={neg ? '#f61a5a' : '#ffffff'}
                outlined={!neg}
                disabled={text !== typeText}
                color={neg ? '#fff' : undefined}
                borderRadius="8px"
                onClick={() => {
                  submitModal();
                  closeModal();
                }}
              >
                {'Cancel'}
              </CustomButton>
            </ButtonWrapper>
          </ButtonsFlexWrapper>
        </ModalMain>
      </WholeWrapper>
    </Modal>
  );
};

export default CancelProgramModal;
